/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import edit from './img/edit.png'
import BaseComponent from "../../../../base/BaseComponent";
import {Table, Input, Checkbox, Button, Modal, Icon, Tree, Select, Popover, Pagination, Form} from "antd";
import {CompactPicker} from 'react-color';
import {message} from '../../components/Mess'
import {Scrollbars} from "react-custom-scrollbars";
import PageTableComponent from "../../components/pageTable/PageTable";
import {HEADER_HEIGHT} from "../../../../constants";
import CmForm from "../../../../components/CmForm/CmForm";
import $ from "jquery";

const {TreeNode} = Tree;
let {Option} = Select;
const {confirm} = Modal;
const {Search} = Input;


export default class Label extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            TreeData: [],//左侧树的数据
            addLabelType: false,//新增标签类型的弹框
            labelType: '', // 新增的标签类型名称
            addType: 'add',// 添加还是编辑类型
            currentTypeId: '', // 编辑标签类型的id


            typeId: '',//当前点击树的id
            searchText: '',//标签名称
            page: 1,
            size: 10,
            addTable: false,
            color: '#0050B3',
            data: [],
            count: 0,
            labelName: '',// 新增的标签名称 右边 新增标签里面
            currentType: '',//新增选中的分类id
            currentName: undefined,//新增选中的分类名称
            status: 'add',
            addHover: false,
            currentId: '',// 编辑标签的id
            leftObj: {
                name: '全部',
                id: '0'
            },//当前左侧树选中的对象
            selectedKeys: ['0'],
            moreVisible:false


        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getTreeList();
        this.getLabelList()
    }

    render() {
        let height = window.innerHeight - HEADER_HEIGHT - 32;
        return (

            <div style={{ display: 'flex',
                margin: "15px 0 15px 15px",
                height: height}}>
                <div style={{width: '260px', height: height,   borderRadius:5,}}>
                    {/*渲染左侧树*/}
                    {this.renderTree()}
                    {this.renderAddLabelType()}
                </div>

                <div style={{width: '100%', height: height, background: '#ffffff', marginLeft: '1px', padding: 24,borderTopRightRadius:5,borderBottomRightRadius:5}}>
                    {/*渲染右边数据*/}
                    {this.renderData()}
                    {this.renderAddLable()}
                </div>
            </div>
        )
    }

    //-----------------左侧树
    renderAddLabelType() {

      
        return (
            <Modal
                maskClosable={false}
                keyboard={true}
                title={this.state.addType === 'add' ? '添加分类' : '编辑分类'}
                visible={this.state.addLabelType}
                onOk={() => this.AddLabelTypehandleOk()}
                width={400}
                centered
                onCancel={() => {
                    this.setState({addLabelType: false})
                }}
            >
                <CmForm onSubmit={() => {
                    this.AddLabelTypehandleOk()
                }}>
                    <div  style={{display:'flex',alignItems: 'center'}}>
                        <div><span style={{color:'red',marginRight:5}}>*</span>分类名称：</div>
                       <div>
                           <Input placeholder="请输入分类名称" style={{width: 240, marginLeft: '12px'}}
                                  maxLength={50}
                                  value={this.state.labelType}
                                  onChange={(e) => {
                                      this.setState({labelType: e.target.value})
                                  }}/>
                       </div>

                    </div>
                </CmForm>
            </Modal>
        )
    }

    //新增标签类型
    AddLabelTypehandleOk() {
        this.state.labelType = this.state.labelType.replace(/\s*/g,"");
        let parms = {name: this.state.labelType};
        if (this.state.labelType) {
            let url;
            if (this.state.addType === 'add') {
                url = '/cm-sites-storage-management/labelType/add'
            } else {
                url = '/cm-sites-storage-management/labelType/editor';
                parms.id = this.state.currentTypeId
            }
            this.request({
                url: url,
                method: "post",
                body: parms,
                contentType: "json",
                callBack: (data) => {
                    if (data) {
                        if (this.state.addType === 'add') {
                            message.success('添加分类成功');
                        } else {
                            message.success('编辑分类成功');
                            this.state.leftObj.name = this.state.labelType;
                            this.setState({},()=>{

                            })
                        }
                        this.setState({addLabelType: false}, () => {
                            this.getTreeList()
                            this.getLabelList()
                        })

                    }
                }
            });
        } else {
            message.error('请填写分类名称！')
        }
    }

    renderTree() {
        const title = <div style={{width: '175px', display: 'flex', }}
                           className={'check-color'}
                           onMouseEnter={() => {
                               this.setState({addHover: true})
                           }} onMouseLeave={() => {
            this.setState({addHover: false})
        }}>
            <div style={{width: '90%'}} onClick={() => {
                this.state.currentName = undefined;
                this.state.leftObj = {name: '全部', id: '0'};
                this.setState({})
            }}>全部
            </div>
            {this.state.addHover ? <div onClick={() => {
                this.setState({addLabelType: true, addType: 'add', labelType: ''})
            }}><Icon type="plus"/></div> : null}
        </div>;

        const content = (data) => {
            return data && data.length && data.map((item, index) => {
                let show;
                if(item.hover){
                    show='visible'
                }else{
                    show='hidden'
                }
                    let childTitle =
                        (<div className={'check-color'}
                              style={{display: 'flex', minWidth: '160px',maxWidth:'100%',padding:'0px 40px 0px 0px'}}
                              key={item.id}
                              onMouseEnter={() => {
                                  item.hover = true;
                                  this.setState({})
                              }}
                              onClick={() => {
                                  this.setState({currentName: item.name, typeId: item.id, leftObj: item}, () => {
                                  },()=>{

                                  })
                              }}
                              onMouseLeave={() => {
                                  item.hover = false;
                                  this.setState({})
                              }}
                        >
                            <div title={item.name} >{item.name}</div>
                            <div style={{visibility:show,width:'50px',paddingLeft:30,display: "flex",
                                alignItems: "center"}}><img src={edit} style={{marginRight:15}}  onClick={() => {
                                this.editType(item)
                            }}/>
                                <Icon type="close" style={{position: 'relative', left: '5px'}}
                                      onClick={() => {
                                          this.deletLabelType(item)
                                      }}/></div>
                        </div>);
                    return (
                        <TreeNode title={childTitle} id={item.id} selectedKeys={item.id} key={item.id}></TreeNode>
                    )
                }
            )
        };
        return (
            <div style={{backgroundColor: '#ffffff',
                height: '100%',width:'100%',minHeight:'300px',borderTopLeftRadius:5,borderBottomLeftRadius:5,
            }}>
                <Scrollbars id={'Scrollbars'}
                    style={{backgroundColor: '#ffffff', borderTopLeftRadius:5,borderBottomLeftRadius:5,paddingBottom:"10px"
                    }}
                >

                        <Tree onSelect={this.onSelect}
                              defaultExpandedKeys={['0']}
                              defaultSelectedKeys={['0']}
                              selectedKeys={this.state.selectedKeys}
                        >
                            <TreeNode title={title} key={'0'} id={'0'}>
                                {content(this.state.TreeData)}
                            </TreeNode>

                        </Tree>

                </Scrollbars>
                <style>
                    {`
                        #Scrollbars>div:nth-child(2){background-color: #fff;bottom: 0px !important;margin-right:6px;}
                        #Scrollbars>div:nth-child(3){background-color: #fff;right: 0px !important;}
                        // #Scrollbars:hover>div:nth-child(2){opacity:1}
                        // #Scrollbars:hover>div:nth-child(3){opacity:1}
                    `}
                </style>
            </div>

        )
    }

    onSelect = (selectedKeys, e) => {
        if (selectedKeys === ['0']) {
            this.setState({typeId: selectedKeys[0]}, () => {
                this.getLabelList()
            })
            // this.setState({selectedKeys:selectedKeys})
        }
        if (e.selected) {
            this.setState({typeId: selectedKeys[0]}, () => {
                this.getLabelList()
            });
            this.setState({selectedKeys: selectedKeys}, () => {
            })
        }

    };

    //编辑类型
    editType(item) {
        this.setState({labelType: item.name, addLabelType: true, addType: 'edit', currentTypeId: item.id})
    }

    delete(record) {
        let that = this;
        let parms = [];
        parms.push(record.id);
        confirm({
            title: '确定要将所选项彻底删除？',
            onOk() {
                that.request({
                    url: "/cm-sites-storage-management/recycle/batchDelete",
                    method: "post",
                    body: parms,
                    contentType: "json",
                    callBack: (data) => {
                        if (data) {
                            message.success('删除成功');
                            that.getList()
                        }
                    }
                });
            },
            onCancel() {
            },
        });
    }

    //删除标签类型
    deletLabelType(item) {
        confirm({
            title: '确定要将所选项删除？',
            onOk: () => {
                this.request({
                    url: "/cm-sites-storage-management/labelType/delete",
                    method: "get",
                    body: {typeId: item.id},
                    callBack: (data) => {
                        if (data) {
                            message.success('删除成功');
                            this.getTreeList();
                            this.setState({selectedKeys: ['0'], currentName : undefined, leftObj: {name: '全部', id: '0'},typeId:'0'},()=>{
                                this.getLabelList()
                            })
                        }
                    }
                });
            },
            onCancel() {
            },
        });
    }

    getTreeList() {
        this.request({
            url: "/cm-sites-storage-management/labelType/getAll",
            method: "get",
            body: '',
            callBack: (data) => {
                this.setState({TreeData: data})
            }
        });
    }

    //--------右侧
    renderAddLable() {
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return (
            <>
                <Modal
                    visible={this.state.addTable}
                    title={this.state.status === 'add' ? '新增标签' : '编辑标签'}
                    onOk={() => this.AddTabelhandleOk()}
                    centered={true}
                    maskClosable={false}
                    keyboard={true}
                    width={400}
                    onCancel={() => {
                        this.setState({addTable:false,moreVisible:false})

                    }}
                >
                <div>
                    <div style={{display:'flex',alignItems: 'center'}}>
                        <div><span style={{color:'red',marginRight:5}}>*</span>标签名称：</div>
                        <div className={"inputName"}><Input placeholder="请输入标签名称" style={{width: 240, marginLeft: '12px'}}
                                    value={this.state.labelName}
                                    maxLength={50}
                                    onChange={(e) => {
                                        this.setState({labelName: e.target.value})
                                    }}/></div>
                    </div>
                    <div style={{display:'flex',alignItems: 'center',marginTop:20}}>
                        <div><span style={{color:'red',marginRight:5}}>*</span>标签分类：</div>
                        <div>
                            <Select
                                placeholder="请输入分类名称"
                                style={{width: 240, marginLeft: '12px'}} value={this.state.currentName}
                                onChange={(value) => this.handleChange(value)}>
                                {
                                    this.state.TreeData && this.state.TreeData.length && this.state.TreeData.map((item, index) => {
                                        return (
                                            <Option value={item.name} key={item.name}>{item.name}</Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                    </div>
                    <div style={{display:'flex',alignItems: 'center',marginTop:20}}>
                        <div><span style={{color:'red',marginRight:5}}>*</span>标签颜色：</div>
                        <div>
                            <Popover placement="right"
                                     visible={this.state.moreVisible}
                                     onVisibleChange={(visible) => this.handleVisibleChange(visible)}
                                     content={
                                         <CompactPicker color={this.state.color} onChange={this.handleColorChange}/>
                                     }
                                     trigger="click"
                            >
                                <div style={{
                                    width: 32,
                                    marginLeft: '12px',
                                    height: 32,
                                     background: ' rgba(0, 80, 179, 0.04)',
                                    borderRadius: '2px',
                                    border: ' 1px solid rgba(0, 80, 179, 0.08)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}

                                >
                                    <div style={{width: 20, height: 20, background: this.state.color, borderRadius: '2px'}}>
                                    </div>
                                </div>
                            </Popover>
                        </div>
                    </div>
                    <style>
                        {
                            `.inputName .ant-input:focus, .ant-input:hover {border-color:${newSecondSelectColor} !important;}`
                        }
                    </style>
                </div>
                </Modal>
            </>
        )
    }
    handleVisibleChange(visible)
    {
        this.setState({moreVisible:visible})
    }

    //选择颜色
    handleColorChange = (colorCode) => {
        this.setState({color: colorCode.hex})
    };

    handleChange(value) {
        this.state.currentName = value;
        this.state.TreeData && this.state.TreeData.length && this.state.TreeData.forEach((item, index) => {
            if (item.name === value) {
                this.state.currentType = item.id
            }
        });
        this.setState({}, () => {
        })

    };

    renderData() {

        let columns = [
            {
                title: '标签名称',
                dataIndex: 'name',
                ellipsis: true,
                width: '40%'
            },
            {
                title: '标签类型',
                dataIndex: 'typeName',
                ellipsis: true,
                width:'15%'
            },
            {
                title: '标签颜色',
                dataIndex: 'color',
                align: 'center',
                width: '15%',
                render: (text, record) => {
                    return (
                        <div style={{width: 24, height: 24, background: text, borderRadius: 2,margin:'0 auto'}}></div>
                    )
                },
            },
            {
                title: '使用次数',
                dataIndex: 'useNum',
                width: '15%',
                align: 'center'
            },
            {
                title: '操作',
                render: (text, record) => {
                    let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
                    return (<div>
                        <span style={{cursor: "pointer", color:newSecondSelectColor,}} onClick={() => {
                            this.editLabel(record)
                        }
                        }>编辑</span>
                        <span style={{marginLeft: '20px', cursor: "pointer", color: 'red'}} onClick={() => {
                            this.deletLabel(record)
                        }}>删除</span>
                    </div>)
                }
            },
        ];
        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <Search
                            allowClear={true}
                            placeholder="请输入关键字"
                            onSearch={value => {
                                this.setState({searchText: value, page: 1}, () => {
                                    this.getLabelList()
                                })
                            }}
                            style={{width: 272}}
                        />
                    </div>
                    <div>
                        <Button type='primary' onClick={() => {
                            if (this.state.leftObj.name === '全部') {
                                this.setState({currentName: undefined, currentType: ''})
                            } else {
                                this.setState({
                                    currentName: this.state.leftObj.name,
                                    currentType: this.state.leftObj.id
                                })
                            }
                            this.setState({addTable: true, status: 'add', labelName: '', color: '#0050B3'})
                        }}>新增标签</Button>
                    </div>

                </div>
                <PageTableComponent columns={columns}
                                    positionHeight={8}
                                    rowSelection={null}
                                    data={this.state.data}
                                    page={this.state.page}
                                    size={this.state.size}
                                    count={this.state.count}
                                    onChangePage={(page, size) => {
                                        this.onChangePage(page, size)
                                    }}
                ></PageTableComponent>

            </div>
        )
    }

    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getLabelList()
        })
    }

    //新增标签  编辑标签
    AddTabelhandleOk() {
        this.state.labelName = this.state.labelName.replace(/\s*/g,"");
        let url;
        if (!this.state.labelName) {
            message.error('请输入标签名称！')
        } else if (!this.state.currentName) {
            message.error('请选择分类名称！')
        } else {
            let parms = {
                name: this.state.labelName,
                color: this.state.color,
                typeId: this.state.currentType,
                typeName: this.state.currentName
            };
            if (this.state.status === 'add') {
                url = '/cm-sites-storage-management/label/add'
            } else {
                url = '/cm-sites-storage-management/label/editor';
                parms.id = this.state.currentId
            }
            this.request({
                url: url,
                method: "post",
                body: parms,
                contentType: "json",
                callBack: (data) => {
                    if (data) {
                        message.success('操作成功');
                        if(this.state.status === 'add'){
                          this.state.page =1
                        }
                        this.state.addTable=false;
                       this.state.moreVisible=false;
                        this.setState({}, () => {
                            this.getLabelList()
                        })

                    }
                }
            });
        }
    }

    //编辑标签
    editLabel(record) {
        this.setState({
            labelName: record.name,
            color: record.color,
            addTable: true,
            status: 'edit',
            currentType:record.typeId,
            currentId: record.id,
            currentName: record.typeName
        })
    }

    //删除标签
    deletLabel(record) {
        let _this = this;
        confirm({
            title: '确定要将所选项删除？',
            onOk() {
                _this.request({
                    url: "/cm-sites-storage-management/label/delete",
                    method: "get",
                    body: {labelId: record.id},
                    callBack: (data) => {
                        if (_this.state.data.length === 1) {
                            _this.onChangePage(_this.state.page - 1, _this.state.size)
                        } else {
                            _this.onChangePage(_this.state.page, _this.state.size)
                        }
                        message.success('删除成功')
                        _this.getLabelList()
                    }
                });
            },
            onCancel() {
            },
        });
    }

    //获取标签列表
    getLabelList() {
        let type = this.state.typeId;
        if (type === '0') {
            type = ''
        }
        let parms = {
            typeId: type,
            page: this.state.page,
            size: this.state.size,
            labelName: this.state.searchText
        };
        this.request({
            url: "/cm-sites-storage-management/label/pageList",
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                this.setState({data: data.data, count: data.count},()=>{
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                })

            }
        });
    }
}